import { render } from "./ResourceRemainderReport.vue?vue&type=template&id=7fb1ac7e&scoped=true"
import script from "./ResourceRemainderReport.vue?vue&type=script&lang=js"
export * from "./ResourceRemainderReport.vue?vue&type=script&lang=js"

import "./ResourceRemainderReport.vue?vue&type=style&index=0&id=7fb1ac7e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb1ac7e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBanner,QLinearProgress,QCard,QCardSection,QField});
